<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M475 1176 c-67 -17 -115 -39 -142 -65 -13 -12 -23 -23 -24 -24 -1 -1
-5 -45 -10 -97 -5 -52 -11 -119 -15 -147 -5 -44 -2 -59 16 -88 18 -28 21 -46
17 -81 -4 -42 -2 -47 30 -71 53 -40 43 -60 -50 -94 -114 -41 -146 -64 -173
-123 -21 -46 -54 -175 -54 -212 0 -12 50 -14 326 -14 l326 0 -7 67 c-3 38 -15
92 -26 121 -10 29 -19 63 -19 75 0 18 -8 13 -46 -31 -57 -66 -76 -66 -136 -4
-53 55 -68 80 -68 118 0 23 3 25 23 19 12 -4 49 -9 83 -12 71 -6 102 6 180 74
50 43 51 46 46 88 -3 34 1 52 18 80 18 30 21 44 15 88 -3 28 -6 72 -5 97 1 97
-10 150 -42 186 -25 28 -37 34 -72 34 -22 0 -59 7 -81 15 -47 17 -46 17 -110
1z m178 -181 c44 -33 47 -38 48 -83 0 -26 3 -41 6 -34 2 6 13 12 23 12 23 0
36 -50 20 -79 -10 -19 -17 -20 -68 -15 -35 4 -71 15 -93 30 -44 30 -64 30
-108 0 -38 -25 -127 -41 -149 -27 -8 5 -12 23 -10 47 2 32 7 40 26 42 15 2 22
-2 24 -15 1 -10 4 9 7 41 l6 59 60 13 c33 6 76 19 95 27 50 22 60 20 113 -18z
m-73 -200 c22 -16 53 -27 91 -31 57 -6 59 -8 59 -35 0 -22 -8 -34 -32 -50 -31
-18 -31 -19 -7 -14 65 16 36 -38 -50 -96 -34 -22 -56 -29 -94 -29 -58 0 -96
17 -156 69 -47 42 -48 67 -2 57 23 -6 24 -5 6 5 -29 17 -45 40 -45 65 0 19 7
22 59 28 38 4 69 15 91 31 19 14 37 25 40 25 3 0 21 -11 40 -25z"
      />
      <path
        d="M955 706 c-8 -13 -13 -30 -9 -39 4 -12 -2 -16 -28 -19 -25 -2 -34 -8
-36 -25 -3 -20 -9 -23 -51 -23 -26 0 -52 -5 -59 -12 -9 -9 -12 -84 -12 -274 0
-230 2 -263 16 -268 9 -3 114 -6 234 -6 207 0 220 1 230 19 6 12 10 115 10
265 0 277 0 276 -73 276 -34 0 -44 4 -52 23 -7 15 -20 23 -42 25 -25 3 -33 8
-33 23 0 59 -64 83 -95 35z m70 -26 c0 -20 -6 -26 -26 -28 -17 -2 -29 3 -32
12 -11 28 4 47 32 44 20 -2 26 -8 26 -28z m-145 -125 c10 -12 37 -15 125 -15
91 0 114 3 119 15 7 18 46 20 69 2 16 -11 17 -35 15 -247 l-3 -235 -194 -3
c-134 -2 -198 1 -207 9 -11 9 -14 58 -14 240 0 207 2 229 18 238 25 15 58 13
72 -4z"
      />
      <path
        d="M862 481 c-8 -4 -12 -21 -10 -37 2 -25 7 -29 32 -29 36 0 56 27 40
53 -13 19 -43 26 -62 13z"
      />
      <path
        d="M965 460 c-14 -22 11 -30 96 -30 82 0 89 1 89 20 0 19 -7 20 -89 20
-50 0 -93 -4 -96 -10z"
      />
      <path
        d="M1036 341 c-9 -9 -16 -30 -16 -45 0 -32 32 -48 84 -39 35 6 36 7 36
52 l0 47 -44 2 c-31 1 -48 -4 -60 -17z m77 -23 c7 -22 -4 -38 -27 -38 -27 0
-46 18 -39 36 6 17 60 18 66 2z"
      />
      <path
        d="M860 330 c0 -13 7 -20 20 -20 19 0 20 -7 20 -100 l0 -100 25 0 25 0
0 120 0 120 -45 0 c-38 0 -45 -3 -45 -20z"
      />
      <path
        d="M1020 225 c0 -12 13 -15 60 -15 47 0 60 3 60 15 0 12 -13 15 -60 15
-47 0 -60 -3 -60 -15z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
